import { useMemo } from 'react';
import { usePreferredCDNs } from '@core/helpers/video/usePreferredCDNs';
import { useVideoWrapperFactory } from '@core/video/videoElementWrapper';
/**
 *
 */
export function useCreateVideoWrapper(props) {
    const { isStoryblock, params, video } = props;
    const videoKey = useMemo(() => {
        if (params.player_key) {
            return params.player_key;
        }
        else if (isStoryblock && params.widget_id) {
            return params.widget_id;
        }
        return 'videoplayer';
    }, [isStoryblock, params.player_key, params.widget_id]);
    const preferredCDNs = usePreferredCDNs(params);
    return useVideoWrapperFactory({
        video,
        key: videoKey,
        // TODO(CS-621): Use the autoplay value from VideoPlayer's props.
        autoplay: true,
        preferredCDNs,
    });
}
